export enum UserGroup {
  ADMIN_TECH = 'admin_tech',
  TEST_NONE = 'none',
  ADMIN_COORDINATOR = 'admin_coordinator',
  NEW_RUN = 'function_new_run',
  /** Cognito groups that gate standalone sidebar pages (see GroupGuard + router-sidebar-items). */
  PAGE_QUESTIONS = 'page_questions',
  PAGE_FEATURES = 'page_features',
  PAGE_SRITEMS = 'page_sritems',
  PAGE_RULES = 'page_rules',
}
